import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className={`footer mt-auto py-3 bg-white text-center`}>
      <div className="container">
        <span className="text-muted">
          {" "}
          Copyright © <span id="year"></span>{" "}
          <Link to={`/`} className="text-dark fw-medium">
            {process.env.REACT_APP_BRAND_NAME}
          </Link>
          . All rights reserved
        </span>
      </div>
    </footer>
  );
};

export default Footer;
